import { LayoutDashboardIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import { cn, shuffleArray } from '@/utils'
import { INSIGHTS_MODULES, INSIGHTS_PHRASES } from './constants'

const PHRASE_INTERVAL_MS = 3500
const FADE_DURATION_MS = 400
const MODULE_STEP_MS = 1500

export function InsightsProgressPanel() {
  const shuffledPhrases = shuffleArray(INSIGHTS_PHRASES)
  const [phraseIndex, setPhraseIndex] = useState(0)
  const [isPhraseVisible, setIsPhraseVisible] = useState(true)
  const [activeModuleIndex, setActiveModuleIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsPhraseVisible(false)
      setTimeout(() => {
        setPhraseIndex((previous) => (previous + 1) % shuffledPhrases.length)
        setIsPhraseVisible(true)
      }, FADE_DURATION_MS)
    }, PHRASE_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [shuffledPhrases.length])

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveModuleIndex(
        (previous) => (previous + 1) % INSIGHTS_MODULES.length,
      )
    }, MODULE_STEP_MS)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center gap-8 py-16">
      <div className="relative h-14 w-14">
        <div className="absolute inset-0 animate-ping rounded-full bg-brand/10 [animation-duration:2s]" />
        <div className="relative flex h-14 w-14 items-center justify-center rounded-full bg-brand/10">
          <LayoutDashboardIcon className="h-6 w-6 text-brand" />
        </div>
      </div>

      <div className="space-y-2 text-center">
        <h2 className="font-semibold text-blue-7 text-lg tracking-tight">
          Building your dashboard
        </h2>
        <p className="text-pretty text-muted-foreground text-sm">
          We're turning this project's transactions into interactive charts and
          flags. Feel free to come back, it'll be waiting for you.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-1.5">
        {INSIGHTS_MODULES.map((moduleName, index) => {
          const isActive = index === activeModuleIndex
          return (
            <div
              key={moduleName}
              className={cn(
                'flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs transition-colors duration-500',
                isActive
                  ? 'border-brand/40 bg-brand/5 text-foreground'
                  : 'bg-white text-muted-foreground',
              )}
            >
              <span
                className={cn(
                  'h-1.5 w-1.5 rounded-full transition-colors duration-500',
                  isActive ? 'bg-brand' : 'bg-blue-3',
                )}
              />
              {moduleName}
            </div>
          )
        })}
      </div>

      <div className="flex h-5 items-center">
        <p
          className={cn(
            'text-muted-foreground text-sm italic transition-opacity duration-400',
            isPhraseVisible ? 'opacity-100' : 'opacity-0',
          )}
        >
          {shuffledPhrases[phraseIndex]}
        </p>
      </div>
    </div>
  )
}
